export default __webpack_public_path__ + "static/media/Mulish-Bold.178a6a4c.ttf";